import "./Social.css";

export default function Social({ img }) {
  return (
    <div className="icon-wrapper d-flex justify-content-center align-items-center">
      <img src={img} alt="social icons" />
    </div>
  );
}
